// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"547":"15580871","6186":"15580871","6353":"15580871"}[chunkId] + ".chunk.css";
};